(() => {
  const root = document.querySelector('[data-review-composer]');
  const section = root?.closest('#hz-product-reviews');
  if (!root || !section) return;
  document.documentElement.classList.add('hz-rokr-ready');
  const write = root.querySelector('[data-review-write]');
  write.addEventListener('click', () => {
    const native = root.querySelector('[data-testid="write-review-button"], .jdgm-write-rev-link');
    if (native) native.click();
  });
  const toggle = root.querySelector('[data-review-filters-toggle]');
  const filters = root.querySelector('[data-review-filters]');
  toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(open));
    filters.classList.toggle('is-open', open);
  });
  const cards = Array.from(section.querySelectorAll('[data-hz-review-card]'));
  if (!cards.length) return;
  const grids = Array.from(new Set(cards.map(card => card.parentElement)));
  const original = new Map(cards.map((card, index) => [card, index]));
  const imageButton = root.querySelector('[data-review-images]');
  const rating = root.querySelector('[data-review-rating]');
  const time = root.querySelector('[data-review-time]');
  const status = root.querySelector('[data-review-status]');
  const more = document.createElement('button');
  more.type = 'button'; more.className = 'hz-rokr-more'; more.textContent = 'Show more';
  grids.at(-1).after(more);
  let limit = 8;
  const dateOf = card => Date.parse(card.dataset.date || card.querySelector('time')?.textContent || '') || 0;
  const apply = () => {
    const cutoff = /^\d+$/.test(time.value) ? Date.now() - Number(time.value) * 86400000 : 0;
    const matches = cards.filter(card =>
      (imageButton.getAttribute('aria-pressed') !== 'true' || card.querySelector('.hz-review-card__image img')) &&
      (rating.value === 'all' || Number(card.dataset.rating) === Number(rating.value)) &&
      (!cutoff || dateOf(card) >= cutoff));
    matches.sort(time.value === 'all' ? (a,b) => original.get(a) - original.get(b) : (a,b) => dateOf(b) - dateOf(a));
    cards.forEach(card => {card.hidden = true;});
    matches.forEach((card,index) => {card.hidden = index >= limit; grids[0].append(card);});
    more.hidden = matches.length <= limit;
    const active = imageButton.getAttribute('aria-pressed') === 'true' || rating.value !== 'all' || time.value !== 'all';
    status.textContent = !matches.length ? 'No reviews match these filters.' : active ? `${matches.length} matching reviews` : '';
    toggle.firstChild.textContent = active ? 'Filters ' : 'All ';
  };
  [rating,time].forEach(control => control.addEventListener('change', () => {limit=8;apply();}));
  imageButton.addEventListener('click', () => {imageButton.setAttribute('aria-pressed', String(imageButton.getAttribute('aria-pressed') !== 'true'));limit=8;apply();});
  more.addEventListener('click', () => {limit+=8;apply();});
  apply();
})();
